import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Notification from "../components/Notification";
import Loading from "../components/Loading";

function GoogleForm() {
    const navigate = useNavigate();
    const giorni = ["Lunedi", "Martedi", "Mercoledi", "Giovedi", "Venerdi"];

    const [corsi, setCorsi] = useState(null);
    const [formData, setFormData] = useState({
        email: "",
        nome: "",
        cognome: "",
        classe: "",
        turno_1: {
            Lunedi: null,
            Martedi: null,
            Mercoledi: null,
            Giovedi: null,
            Venerdi: null,
        },
        turno_2: {
            Lunedi: null,
            Martedi: null,
            Mercoledi: null,
            Giovedi: null,
            Venerdi: null,
        },
    });
    const [notification, setNotification] = useState(null);
    const [showLoading, setShowLoading] = useState(false);

    useEffect(() => {
        setShowLoading(true);
        fetch("https://googleform.kmsolution.link/api/available_courses.php")
            .then((response) => response.json())
            .then((data) => {
                console.log("Disponibilità corsi:", data);
                setCorsi(data);
            })
            .catch((error) => addNotification(`Errore: ${error}`, 'ERROR'))
            .finally(() => setShowLoading(false));
    }, []);

    const addNotification = (message, type, duration = 4000) => {
        setNotification({ message, type });
        setTimeout(() => setNotification(null), duration);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleTurnoChange = (giorno, turno, value) => {
        setFormData((prevState) => ({
            ...prevState,
            [turno]: {
                ...prevState[turno],
                [giorno]: value,
            },
        }));
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();

        if (!formData.email || !formData.nome || !formData.cognome || !formData.classe) {
            addNotification("Compila tutti i dati personali", 'WARNING');
            return;
        }
        if (!Object.keys(formData.turno_1).length || Object.values(formData.turno_1).some((corso) => corso === null)) {
            addNotification("Seleziona un corso per ogni giorno del turno 1", 'WARNING');
            return;
        }
        if (!Object.keys(formData.turno_2).length || Object.values(formData.turno_2).some((corso) => corso === null)) {
            addNotification("Seleziona un corso per ogni giorno del turno 2", 'WARNING');
            return;
        }
        if (!/^[a-z0-9]+\.[a-z0-9]+@istitutomaggia\.it$/.test(formData.email)) {
            addNotification("Inserisci una email scolastica valida", 'WARNING');
            return;
        }

        console.log("Dati inviati al backend:", formData);
        // addNotification("Invio in corso...", 'INFO');

        setShowLoading(true);

        fetch("https://googleform.kmsolution.link/api/save_response.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === "success") {
                    addNotification(data.message, 'SUCCESS');
                    setFormData({
                        email: "",
                        nome: "",
                        cognome: "",
                        classe: "",
                        turno_1: {},
                        turno_2: {},
                    });
                    navigate("/thank-you");
                } else {
                    addNotification(data.message, 'ERROR');
                }
            })
            .catch((error) => addNotification(`Errore: ${error}`, 'ERROR'))
            .finally(() => setShowLoading(false));
    };

    return (
        <>
            {notification && <Notification
                message={notification.message}
                type={notification.type}
            />}

            <main className="container my-10 max-w-3xl flex flex-col gap-10">

                <section className="card border-t-8 border-t-orange-500">
                    <h1>ISCRIZIONE AI CORSI DI EDUCAZIONE CIVICA</h1>

                    <p>
                        Ricorda che puoi iscriverti ad un solo corso al giorno nel primo turno ed uno solo al secondo turno.
                        <br />
                        Sarà vostra cura segnarvi in quali corsi parteciperete, riceverete comunque una email dopo aver
                        consegnato il modulo.
                        <br />
                        INSERISCI QUI SOTTO LA TUA E-MAIL SCOLASTICA (nome.cognome@istitutomaggia.it)
                    </p>

                    <hr className="my-4" />

                    <p className="text-red-600">
                        * Indica una domanda obbligatoria
                    </p>
                </section>

                <section className="card">
                    <form className="validate-form">
                        <div className="form-input validate-input" data-validate="Email valida: nome.cognome@istitutomaggia.it">
                            <label htmlFor="email" className="title">Email *</label>
                            <input className="form-element" type="email" id="email" name="email"
                                placeholder="nome.cognome@istitutomaggia.it" required
                                value={formData.email} onChange={handleChange} />
                        </div>
                    </form>
                </section>

                <section className="card">
                    <form className="validate-form">
                        <div className="grid lg:grid-cols-2 gap-10 mb-10">
                            <div className="form-input validate-input" data-validate="Obbligatorio">
                                <label htmlFor="nome" className="title">Nome *</label>
                                <input className="form-element" type="text" id="nome" name="nome" required
                                    value={formData.nome} onChange={handleChange} />
                            </div>
                            <div className="form-input validate-input" data-validate="Obbligatorio">
                                <label htmlFor="cognome" className="title">Cognome *</label>
                                <input className="form-element" type="text" id="cognome" name="cognome" required
                                    value={formData.cognome} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="form-input validate-input" data-validate="Obbligatorio">
                            <label htmlFor="classe" className="title">Classe *</label>
                            <input className="form-element" type="text" id="classe" name="classe" required
                                value={formData.classe} onChange={handleChange} />
                        </div>
                    </form>
                </section>

                <section className="card">
                    <h2>1° TURNO *</h2>
                    <form>
                        {giorni.map((giorno, index) => (
                            <div key={index} className="mt-10">
                                <h3 className="h3 uppercase">{giorno}</h3>
                                {corsi && corsi.turno_1[giorno] && Object.entries(corsi.turno_1[giorno]).map(([corso, disponibilita], index) => (
                                    <div key={index} className="form-input flex flex-col lg:flex-row lg:items-center justify-between mb-2">
                                        <div className="flex items-center">
                                            <input type="radio" id={`${giorno}_turno_1_${index}`} name={`turno_1_${giorno}`} value={corso}
                                                disabled={disponibilita === 0}
                                                checked={formData.turno_1[giorno] === corso}
                                                onChange={() => handleTurnoChange(giorno, "turno_1", corso)}
                                            />
                                            <label htmlFor={`${giorno}_turno_1_${index}`} className={`flex-1 ${disponibilita === 0 && 'disabled'}`}>{corso}</label>
                                        </div>
                                        <span className="text-gray-500">Posti: {disponibilita}</span>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </form>
                </section>

                <section className="card">
                    <h2>2° TURNO *</h2>
                    <form>
                        {giorni.map((giorno, index) => (
                            <div key={index} className="mt-10">
                                <h3 className="h3 uppercase">{giorno}</h3>
                                {corsi && corsi.turno_2[giorno] && Object.entries(corsi.turno_2[giorno]).map(([corso, disponibilita], index) => (
                                    <div key={index} className="form-input flex flex-col lg:flex-row lg:items-center justify-between mb-2">
                                        <div className="flex items-center">
                                            <input type="radio" id={`${giorno}_turno_2_${index}`} name={`turno_2_${giorno}`} value={corso}
                                                checked={formData.turno_2[giorno] === corso}
                                                onChange={() => handleTurnoChange(giorno, "turno_2", corso)}
                                            />
                                            <label htmlFor={`${giorno}_turno_2_${index}`} className="flex-1">{corso}</label>
                                        </div>
                                        <span className="text-gray-500">Posti: {disponibilita}</span>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </form>
                </section>

                <section className="flex items-center justify-between">
                    <button className="btn" onClick={handleFormSubmit}>
                        Invia
                    </button>
                    {showLoading && <Loading width="40px" height="20px" />}
                </section>

            </main>
        </>
    );
}

export default GoogleForm;